import React, { useEffect, useState } from 'react';
import {
  Container, Typography, Box, Button, Table, TableBody, TableCell,
  TableHead, TableRow, Paper, IconButton, Chip, Alert, CircularProgress
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../../services/api';

const AdminVehicleBrands = () => {
  const navigate = useNavigate();
  const [brands, setBrands] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const fetchBrands = async () => {
    try {
      const res = await axiosInstance.get('/vehiclebrands');
      setBrands(res.data);
    } catch {
      setError('Markalar yüklenemedi.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchBrands(); }, []);

  const handleDelete = async (id) => {
    if (!window.confirm('Bu markayı silmek istediğinizden emin misiniz?')) return;
    try {
      const token = localStorage.getItem('adminToken');
      await axiosInstance.delete(`/vehiclebrands/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setBrands(prev => prev.filter(b => b.id !== id));
    } catch {
      setError('Silme işlemi başarısız.');
    }
  };

  return (
    <Container maxWidth="lg">
      <Box sx={{ mt: 4, mb: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="h5" fontWeight={700}>Araç Markaları</Typography>
        <Button variant="contained" startIcon={<AddIcon />} onClick={() => navigate('/admin/vehicles/brands/new')}>
          Yeni Marka
        </Button>
      </Box>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      {loading ? <CircularProgress /> : (
        <Paper>
          <Table>
            <TableHead>
              <TableRow sx={{ bgcolor: 'primary.main' }}>
                <TableCell sx={{ color: 'white', fontWeight: 700 }}>Marka</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 700 }}>Slug</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 700 }}>Sıra</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 700 }}>Durum</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 700 }} align="right">İşlemler</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {brands.map(b => (
                <TableRow key={b.id} hover>
                  <TableCell><strong>{b.name}</strong></TableCell>
                  <TableCell>{b.slug}</TableCell>
                  <TableCell>{b.displayOrder}</TableCell>
                  <TableCell>
                    <Chip label={b.status ? 'Aktif' : 'Pasif'} color={b.status ? 'success' : 'default'} size="small" />
                  </TableCell>
                  <TableCell align="right">
                    <IconButton color="primary" onClick={() => navigate(`/admin/vehicles/brands/edit/${b.id}`)}>
                      <EditIcon />
                    </IconButton>
                    <IconButton color="error" onClick={() => handleDelete(b.id)}>
                      <DeleteIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
              {brands.length === 0 && (
                <TableRow><TableCell colSpan={5} align="center">Henüz marka eklenmemiş.</TableCell></TableRow>
              )}
            </TableBody>
          </Table>
        </Paper>
      )}
    </Container>
  );
};

export default AdminVehicleBrands;
